if (!customElements.get('scrolling-promotion')) {
  class ScrollingPromotion extends HTMLElement {
    constructor() {
      super();
      this.promotion = this.querySelector('.promotion');
      this.staticCountdownItem = this.promotion?.querySelector('.promotion__item-countdown') || null;
      this.countdownInterval = null;
      this.ukTimeFormatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hourCycle: 'h23',
      });

      if (this.staticCountdownItem) {
        this.enableStaticCountdownMode();
      }

      this.prepareCountdowns();
      this.updateCountdowns();

      if (this.querySelector('[data-scrolling-countdown][data-countdown-timestamp]')) {
        this.countdownInterval = setInterval(() => this.updateCountdowns(), 1000);
      }

      if (this.staticCountdownItem || FoxTheme.config.motionReduced) return;
      FoxTheme.Motion.inView(this, this.init.bind(this), { margin: '200px 0px 200px 0px' });
    }

    disconnectedCallback() {
      if (this.countdownInterval) {
        clearInterval(this.countdownInterval);
      }
    }

    enableStaticCountdownMode() {
      this.classList.add('scrolling-promotion--static-countdown');
      this.promotion.classList.add('promotion--static-countdown');
      this.promotion.style.flex = '1 1 100%';
      this.promotion.style.width = '100%';
      this.promotion.style.justifyContent = 'center';

      this.promotion.querySelectorAll('.promotion__item').forEach((item) => {
        if (item !== this.staticCountdownItem) {
          item.style.display = 'none';
        }
      });
    }

    prepareCountdowns() {
      this.querySelectorAll('[data-scrolling-countdown]').forEach((countdown) => {
        const timestamp = this.getUkTimestamp(countdown.dataset.countdownDate, countdown.dataset.countdownTime);

        if (Number.isFinite(timestamp)) {
          countdown.dataset.countdownTimestamp = timestamp.toString();
        }
      });
    }

    getUkTimestamp(dateString, timeString) {
      const dateMatch = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dateString || '');
      const timeMatch = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(timeString || '');

      if (!dateMatch || !timeMatch) return Number.NaN;

      const year = Number(dateMatch[1]);
      const month = Number(dateMatch[2]);
      const day = Number(dateMatch[3]);
      const hour = Number(timeMatch[1]);
      const minute = Number(timeMatch[2]);
      const wallClockUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
      const validationDate = new Date(wallClockUtc);

      if (
        validationDate.getUTCFullYear() !== year ||
        validationDate.getUTCMonth() !== month - 1 ||
        validationDate.getUTCDate() !== day
      ) {
        return Number.NaN;
      }

      let timestamp = wallClockUtc;
      for (let attempt = 0; attempt < 3; attempt += 1) {
        timestamp = wallClockUtc - this.getUkOffset(timestamp);
      }

      return timestamp;
    }

    getUkOffset(timestamp) {
      const parts = this.ukTimeFormatter.formatToParts(new Date(timestamp));
      const values = {};

      parts.forEach((part) => {
        if (part.type !== 'literal') {
          values[part.type] = Number(part.value);
        }
      });

      const representedAsUtc = Date.UTC(
        values.year,
        values.month - 1,
        values.day,
        values.hour,
        values.minute,
        values.second
      );

      return representedAsUtc - timestamp;
    }

    updateCountdowns() {
      const now = Date.now();
      let hasActiveCountdown = false;

      this.querySelectorAll('[data-scrolling-countdown][data-countdown-timestamp]').forEach((countdown) => {
        const target = Number(countdown.dataset.countdownTimestamp);
        const value = countdown.querySelector('[data-countdown-value]');

        if (!value || !Number.isFinite(target)) return;

        const remaining = Math.max(0, target - now);
        if (remaining > 0) hasActiveCountdown = true;

        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        const pad = (number) => String(number).padStart(2, '0');

        value.textContent = `${pad(days)}d ${pad(hours)}h ${pad(minutes)}m ${pad(seconds)}s`;
      });

      if (!hasActiveCountdown && this.countdownInterval) {
        clearInterval(this.countdownInterval);
        this.countdownInterval = null;
      }
    }

    init() {
      if (this.childElementCount === 1) {
        this.promotion.classList.add('promotion--animated');

        for (let index = 0; index < 10; index++) {
          this.clone = this.promotion.cloneNode(true);
          this.appendChild(this.clone);
        }

        this.updateCountdowns();

        // pause when out of view
        const observer = new IntersectionObserver(
          (entries, _observer) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.scrollingPlay();
              } else {
                this.scrollingPause();
              }
            });
          },
          { rootMargin: '0px 0px 50px 0px' }
        );

        observer.observe(this);
      }
    }

    scrollingPlay() {
      this.classList.remove('scrolling-promotion--paused');
    }

    scrollingPause() {
      this.classList.add('scrolling-promotion--paused');
    }
  }
  customElements.define('scrolling-promotion', ScrollingPromotion);
}
